import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Layout, Table, Row, Col, Button, Icon, Input } from 'antd'

import ParamGroupPopup from '@components/Popup/ParamGroupPopup'

import * as style from './style.scss'

@inject((store: any) => {
    const { popupStore, paramGroupsStore } = store
    return { popupStore, paramGroupsStore }
})
@observer
class ParamGroups extends Component<any, any> {
    render() {
        const { popupStore } = this.props
        const { filteredList, filterText, filterList } = this.props.paramGroupsStore
        const columns = [
            {
                title: 'מזהה',
                key: 'id',
                width: 200,
                align: 'right',
                render: (_, record) => <span>{record.id}</span>
            },
            {
                title: 'שם קבוצת הפרמטרים',
                key: 'name',
                align: 'right',
                render: (_, record) => <span>{record.name}</span>
            },
            {
                title: 'עודכן ע"י',
                key: 'updated_by',
                render: (_, record) => <span>{record.updated_by}</span>
            },
            {
                title: 'עדכון אחרון',
                key: 'updated_at',
                render: (_, record) => <span>{record.updated_at}</span>
            }
        ]
        return (
            <Layout style={{ padding: '1rem', backgroundColor: 'white' }}>
                <Row>
                    <Col xs={4}>
                        <Button style={{ width: '98%' }} onClick={() => popupStore.togglePopup('paramGroup')}>
                            <Icon type="plus" /> הוסף קבוצת פרמטרים
                        </Button>
                    </Col>
                    <Col xs={20}>
                        <Input.Search
                            placeholder="חפש קבוצת פרמטרים על פי שם"
                            onChange={e => filterList(e.target.value)}
                            value={filterText}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div className="box">
                            <Table
                                className="center-table"
                                style={{ width: '100%' }}
                                rowKey="id"
                                columns={columns}
                                onRow={record => ({
                                    onClick: () => popupStore.togglePopup('paramGroup', { ...record })
                                })}
                                rowClassName={() => style.user_row}
                                dataSource={filteredList}
                                pagination={{
                                    pageSize: 10
                                }}
                            />
                        </div>
                    </Col>
                </Row>
                <ParamGroupPopup />
            </Layout>
        )
    }
}

export default ParamGroups
